import { put } from 'redux-saga/effects'
import { apiReject } from '../redux/api/actions'

export function* GlobalHandler(effect, putApiReject: boolean = true) {
  try {
    return yield { response: yield effect, error: null }
  } catch (error) {
    if (putApiReject) yield put(apiReject(error))
    return yield { response: null, error }
  }
}
